import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { ConfirmDialog as RecConfirmDialog } from "components/AtomsV2";
import { closeWarningAlert, selectWarningAlert } from "state/application/applicationSlice";

/* Global confirmation dialog driven by the `warningAlert` redux state, rendered
   in the revamp style (centered tinted icon + title + body + cancel/confirm). */
function ConfirmDialog() {
  const { t } = useTranslation(["common"]);
  const dispatch = useDispatch();
  const warningAlert = useSelector(selectWarningAlert);

  const handleClose = () => dispatch(closeWarningAlert());

  const handleConfirm = async () => {
    const action = warningAlert.confirmAction;
    dispatch(closeWarningAlert());
    if (action) await action();
  };

  return (
    <RecConfirmDialog
      open={!!warningAlert.active}
      danger={!!warningAlert.isDangerous}
      icon={warningAlert.icon || undefined}
      title={warningAlert.title || t("confirm_modal.title")}
      body={warningAlert.text || t("confirm_modal.irreversible")}
      confirmLabel={warningAlert.confirmText || t("confirm")}
      cancelLabel={t("cancel")}
      onCancel={handleClose}
      onConfirm={handleConfirm}
    />
  );
}

export default ConfirmDialog;
